import { jsx as _jsx } from "react/jsx-runtime";
import MenuIcon from "@mui/icons-material/Menu";
import { ExtraSmallFab } from "../Buttons/ExtraSmallFAB";
export const MobileMenuButton = ({ setIsDrawerOpen }) => {
    return _jsx(ExtraSmallFab, { icon: MenuIcon, "aria-label": "close", onClick: () => setIsDrawerOpen(true) });
};
